import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Berghotel-oberhof**
 *
 * @exports bs_207
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  engine._isLoading = function () {
    const loadingEl = document.querySelector && document.querySelector('.vsc-loading, .vri-loading');
    return !!((loadingEl));
  };

  /**
     * @memberOf module:bs_207
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {
    // Check if we are in a BE page}}
    let beContainer;

    if ([1033780, 1027040].includes(thn.data.propertyId)) {
      beContainer = document.querySelector('html');
      if (beContainer && !thn.berghotelObserver) {
        const berghotelRefresh = thn.debounce(function () {
          thn.pageCheck();
        }, 600);

        thn.berghotelObserver = function (mutations) {
          // valid_mutations to detect when we change from Index to calendar...
          const mutationPage = [...mutations].map((mutation) => mutation.type === 'attributes' && mutation.target && mutation.target.id === 'vri-overlay-holder').filter(Boolean).filter((el) => !thn.empty(el));
          const breadcrumbEls = Array.from(document.querySelectorAll('.vsc-navigation-item'));
          if (mutationPage.length || breadcrumbEls.length) {
            berghotelRefresh();
          }
        };

        thn.observeDom(beContainer, thn.berghotelObserver, {
          childList: true,
          subTree: true,
          attributes: true,
          characterData: true,
        });

        thn.shutdown(() => {
          berghotelRefresh.cancel();
          thn.stopObserveDom(beContainer, thn.berghotelObserver);
          delete thn.berghotelObserver;
        });
      }
    } else {

      const dataLayer = window.dataLayer;
      const debounceCallback = thn.debounce(() => {
        thn.pageCheck();

        if (thn.data.pageName === 'Rooms and Rates') {
          thn.widgets.price.refresh();
        }

      }, 500);

      if (dataLayer) {
        let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
          if ((message?.event === 'virtual_pageview' || message?.event === 'cartUpdate')) {
            debounceCallback();
          }
        }, true);
        thn.shutdown(() => {
          dataLayerHelper.cancel();
          dataLayerHelper = null;
        });
      }

      beContainer = document.querySelector('.vsc.vsc-remote');

      if (beContainer) {

        const vscInit = function () {
          // Detect page changes caused by the breadcrumb
          const breadcrumbEls = Array.from(document.querySelectorAll('.vsc-navigation-item'));

          if (breadcrumbEls.length) {
            // Initial state
            thn.data.vscBreadcrumbActiveItem = document.querySelector('li.vsc-navigation-item-active');

            thn.vscBreadcrumbObserver = thn.debounce(function thnVscBreadcrumbObserver() {
              const breadcrumbActiveItem = document.querySelector('li.vsc-navigation-item-active');

              // The active item changed
              if (thn.data.vscBreadcrumbActiveItem !== breadcrumbActiveItem) {
                thn.pageCheck();

                // If we are in R&R, refresh widget
                if (['Rooms and Rates', 'Packages'].includes(thn.data.pageName) && thn.widgets.price.refresh() && !thn.widgets.price.isSet()) {
                  thn.widgets.price.hide();
                }

                thn.data.vscBreadcrumbActiveItem = breadcrumbActiveItem;
              }
            }, 500);

            const breadcrumbObserverConfig = {
              childList: true,
              subtree: true,
              characterData: false,
              attributes: true,
              attributeFilter: ['class'],
            };

            // Observe every breadcrumb item
            breadcrumbEls.forEach(function (el) {
              thn.observeDom(el, thn.vscBreadcrumbObserver, breadcrumbObserverConfig);
              thn.shutdown(function () {
                thn.stopObserveDom(el, thn.vscBreadcrumbObserver, breadcrumbObserverConfig);
              });
            });

            thn.shutdown(function () {
              delete thn.vscBreadcrumbObserver;
              delete thn.data.vscBreadcrumbActiveItem;
            });
          }

          // Detect page changes caused by click on "Next" buttons
          const undelegate = thn.delegate('click', '.vsc-button-next', function () {
            setTimeout(function () {
              thn.pageCheck();

              // If we are in R&R, refresh widget
              if (['Rooms and Rates', 'Packages'].includes(thn.data.pageName) && thn.widgets.price.refresh() && !thn.widgets.price.isSet()) {
                thn.widgets.price.hide();
              }
            }, 1000);
          }, true);

          thn.shutdown(undelegate);
        };

        // Detect page changes caused by loadings
        if (!thn.vscLoadingObserver) {
          // Initial state
          thn.data.vscIsLoading = engine._isLoading();

          // If BE is loaded, init the breadcrumb observer
          if (!thn.data.vscIsLoading) {
            setTimeout(vscInit, 400);
          }

          // The BE is still loading and we cannot determine the proper BE Page yet
          thn.vscLoadingObserver = thn.debounce(function thnVscLoadingObserver() {
            const isLoading = engine._isLoading();

            // Loading just hid
            if (thn.data.vscIsLoading && !isLoading) {
              // If BE is loaded, init the breadcrumb observer
              vscInit();

              // Check if page changed
              thn.pageCheck();

              // If we are in R&R, refresh widget
              if (['Rooms and Rates', 'Packages'].includes(thn.data.pageName) && thn.widgets.price.refresh() && !thn.widgets.price.isSet()) {
                thn.widgets.price.hide();
              }
            }

            thn.data.vscIsLoading = isLoading;
          }, 500);

          thn.observeDom(beContainer, thn.vscLoadingObserver, {
            childList: true,
            subtree: true,
            characterData: false,
            attributes: false,
          });

          thn.shutdown(function () {
            thn.stopObserveDom(beContainer, thn.vscLoadingObserver);
            delete thn.vscLoadingObserver;
            delete thn.data.vscIsLoading;
          });
        }
      }
    }
  };

  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      let aux;

      if (thn.data.propertyId === 1015158) { // Berghotel Oberhof
        resolve('de');
        return;
      }

      if (thn.data.propertyId === 1024296) { // Oberforsthof Hotel
        aux = window.language;
        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }
      }

      reject('no_language');
    });
  };

  engine.priceObserveDom = function priceObserveDom(ctx) {

    const $ = window.jQuery;

    const isMobile = window.location.pathname.substr(0, 7) === '/mobile';

    // If the observer is already set Exit
    // Only execute for Desktop
    if (thn.onReztripClick || isMobile) {
      return;
    }

    thn.onReztripClick = function onReztripClick() {

      // IMPORTANT NOTE: this app deletes ALL of the DOM, thus observers,
      // widgets, etc must be destroyed and regenerated

      // remove old observer
      if (thn.reztripUpdate) {
        // remove the observer
        thn.stopObserveDom($('html').get(0), thn.reztripUpdate);
        delete thn.reztripUdpate;
      }

      // define a new update function
      thn.reztripUpdate = thn.debounce(function thnReztripUpdate() {
        // const $loader = $('#loading');
        ctx.widget.logger.debug('*************** DOM Changed **************');
        // once the loader is not visible
        // if ($loader.length && !$loader.is(':visible')) {
        // remove the observer
        thn.stopObserveDom($('html').get(0), thn.reztripUpdate);
        delete thn.reztripUdpate;
        // then update ...
        // reset lang
        thn.languageCheck().then(function ({ changed }) {
          // reset PW
          if (!changed) {
            thn.widgets.price.reset().destroy().init();
          }
        });
        // }
      }, 400);

      // start observation on loader
      thn.observeDom($('html').get(0), thn.reztripUpdate, {
        subtree: false,
      });

      // exec now
      thn.reztripUpdate();

    }; // on_reztrip_click

    $(document).on('click', '.search-form-submit .button, .button.submit', thn.onReztripClick);

    thn.pageUnload(function () {
      $(document).off('click', '.search-form-submit .button, .button.submit', thn.onReztripClick);
      delete thn.onReztripClick;
    });

  };

  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    // Deeplink: https://www.hotel-forsthaus-nuernberg-fuerth.de/buchen#/vsc.php?calendar_date_from=2024-07-20&calendar_stays=3&persons_adults=2&package=33643
    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/buchen/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    const urlSearchParams = new URLSearchParams(url);

    // Add query params
    urlSearchParams.set('calendar_date_from', '[date_begin]');
    urlSearchParams.set('calendar_stays', '[nights]');
    urlSearchParams.set('persons_adults', '[adults]');

    ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');

    url.hash = `/vsc.php?${urlSearchParams}`;

    // Export into ctx.newUrl
    ctx.newUrl = url.toString();

    return ctx;
  };

  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;
    const isMobile = window.location.pathname.substr(0, 7) === '/mobile';

    // IMPORTANT: DO NOT forbid PW execution
    // on promocode presence anymore. Please add exceptions for
    // the problematical codes/hotels when needed.
    const promocodeBlacklist = {
      PROM3: {
        propertyIds: [1014039],
      },
      TIPSY: {
        propertyIds: [1014039],
      },
      PAI: {
        propertyIds: [1014543],
      },
      SUMZAI: {
        propertyIds: [1014543],
      },
      RPKG: {
        propertyIds: [1014543],
      },
      DREAMY: {
        propertyIds: [1014543],
      },
    };
    const { promocode } = ctx.widget.getPromocode();
    // list here hotels which must NOT show PW with promocode presence
    const isPromocodeException = [].includes(thn.data.accountUserId)
      || [].includes(thn.data.propertyId);

    const isPromocodeBlacklisted = Object.keys(promocodeBlacklist).some(function (pattern) {
      const value = promocodeBlacklist[pattern];
      return !!(
        // The promocode matches the blacklist pattern
        promocode.match(new RegExp(pattern))
        && (
          // Or it is a "global" pattern
          thn.empty(value)
          // Or the pattern applies to this property
          || value.propertyIds.includes(thn.data.propertyId)
        )
      );
    });

    // if hash includes items[]=hrt={number}, it is a search for a filtered room.
    if ((thn.parseUrlParameter('package_variant') && thn.data.propertyId === 1024295) || window.location.hash.match(/items\[\]=hrt:\d+/)) {
      widgetData.priceSpecial = 1;
    }

    if (promocode // promocode presence AND
      && (
        isPromocodeException // whether the property is an exception
        || isPromocodeBlacklisted // OR the promocode is blacklisted
      )
    ) {
      // Do not execute PW at all
      this.logger.debug('Detected a promocode or rate: avoid PW comparison');
      return widgetData;
    }

    if (isMobile) { // Mobile Version

      widgetData.dateBegin = (window.sd || '').replace(/-/g, '/');
      widgetData.dateEnd = (window.ed || '').replace(/-/g, '/');

      widgetData.adults = parseInt(window.na, 10) || 2;
      widgetData.children = parseInt(window.nc, 10) || 0;
      widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);

      widgetData.rooms = parseInt(window.nr, 10) || 1;

      widgetData.currency = thn.getCurrencyCode(window.cc);

      const prices = [];

      if (document.getElementsByClassName('card_price-actual')) {
        const priceEls = document.querySelectorAll('strong.card_price-actual.text-medium.text-lg.move-left.rm-rate.-theme-color');
        for (let i = 0; i < priceEls.length; i += 1) {
          prices.push(thn.parseNumber(priceEls[i].innerText));
        }
      }

      if (prices.length) {
        widgetData.price = Math.min(...prices); // price is per night
        widgetData.set = true;
      } else if ($('#errorAlertPopup:visible').length) {
        widgetData.noRooms = true;
      }

    } else { // Desktop

      // Searches can be for more than one room
      // but only one is shown at the same time on the screen
      widgetData.rooms = 1;

      // Pick guests of the first room
      widgetData.adults = thn.parseNumber(document.querySelector('select[data-trigger-onchange="off"]')?.value) || 2;

      // Children are only detected once we add them insde the iframe and everytime we add one a new selector with the same tag is added, thus we -1 this element
      widgetData.children = [...document.getElementsByClassName('vsc-title vsc-item-roomtypes-alloc-item vsc-item-roomtypes-alloc-item-child')].length - 1 || 0;

      // Currency of elements DOM
      widgetData.currency = thn.parseCurrency(document.querySelector('.mo_price_avail, span.rooms_price strong.ng-binding')?.textContent);

      // When the quoteList object does exist, trust it
      if (window.quoteList && !thn.empty(window.quoteList)) {

        widgetData.price = Number.MAX_VALUE;

        widgetData.dateBegin = (window.quoteList[0].sd || '').replace(/-/g, '/');
        widgetData.dateEnd = (window.quoteList[0].ed || '').replace(/-/g, '/');

        window.quoteList.forEach(function (quote) {
          // price is per_night already
          const price = thn.parseNumber(quote.lr);
          if (price < widgetData.price) {
            widgetData.price = price;
            // If guests where not detected
            // fallback to the guests in the cheapest room
            if (thn.empty(widgetData.adults)) {
              widgetData.adults = quote.na;
            }
            if (thn.empty(widgetData.children)) {
              widgetData.children = quote.nc;
            }
          }
        });

        // Reset price if something was wrong
        if (widgetData.price === Number.MAX_VALUE) {
          widgetData.price = undefined;
        } else {
          widgetData.set = true;
        }

        // Trust currency from quoteList over the URL
        widgetData.currency = window.quoteList[0].cc;

      } else {

        // Dates
        const dates = document.querySelectorAll('.vsc-item-calendar .vsc-item-collapsed-item-value');
        const dateBegin = !thn.empty(dates) && (translateDate(dates[0].textContent, thn.data.language) || dates[0]?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'));
        let dateEnd;
        if (thn.data.language === 'en') {
          dateEnd = !thn.empty(dates) && (translateDate(dates[1].textContent, thn.data.language) || dates[1]?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'));
        } else {
          dateEnd = !thn.empty(dates) && (translateDate(dates[1].textContent, thn.data.language) || dates[1]?.textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'));
        }
        widgetData.dateBegin = dateBegin;
        widgetData.dateEnd = dateEnd;
        // Price
        const priceEls = document.querySelectorAll('.mo_price_avail, span.rooms_price strong.ng-binding');
        if (priceEls.length) {
          // Currency fallback
          if (!widgetData.currency) {
            widgetData.currency = thn.getCurrencyCode((priceEls[0].textContent.match(/[^\d\s,.]+/) || [])[0]);
          }

          const prices = Array.from(priceEls).map(function (priceEl) {
            return thn.parseNumber(priceEl.textContent);
          });

          widgetData.price = Math.min(...prices);
          // Price per night
          if (widgetData.price && widgetData.dateBegin && widgetData.dateEnd) {
            widgetData.price /= thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
          }

          widgetData.set = true;
        } else {
          widgetData.noRooms = true;
        }
      }

      // If price remains empty, this might be a noRooms
      if (thn.empty(widgetData.price)) {
        widgetData.noRooms = true;
      }

      // Guests
      widgetData.adults = parseInt(widgetData.adults, 10) || 2;
      widgetData.children = parseInt(widgetData.children, 10) || 0;
      widgetData.guests = widgetData.adults + widgetData.children;
    }

    return widgetData;

  };

  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;

    const vsc = window[(Object.keys(window).filter(function (propertyName) {
      return propertyName.match(/^_vsc[0-9]*/g);
    }) || [])[0]];

    const vscBooking = vsc && vsc.modules && vsc.modules.booking;
    const vscCart = vscBooking?.vsc?.options?.cart;

    // booking id
    const bookingId = thn.dataLayerHelper.get('booking_id') || vscBooking?.items?.b_id || window.rtCONFIRMATIONNUMBER_0;

    if (!bookingId) {
      widgetData.set = false;
      thn.logger.debug('Booking Id Missing...');
      return widgetData;
    }

    widgetData.bookingId = bookingId;

    // Dates
    const vscCal = vscCart && vscCart.calendar;
    const dateBegin = thn.dataLayerHelper.get('date_from') || vscCal?.date_from.date || window.rtARRIVAL_0;
    const dateEnd = thn.dataLayerHelper.get('date_to') || vscCal?.date_to.date || window.rtDEPARTURE_0;

    widgetData.dateBegin = dateBegin?.replace(/-/g, '/');
    widgetData.dateEnd = dateEnd?.replace(/-/g, '/');

    const vscPrice = vscCart && vscCart.prices?.sum_trip;
    const price = thn.parseNumber(thn.objectGet(vsc, 'sum_items_value') || thn.objectGet(dataLayer, 'actionField', { first: false })?.revenue || window.rtTOTALCOSTWITHTAXES) || (!thn.empty(vscPrice) && parseFloat(vscPrice));
    const currency = thn.objectGet(vsc, 'currency_name_short') || (!thn.empty(vscPrice) && thn.getCurrencyCode(vscPrice.currency_name_short)) || window.rtCURRENCYCODE;

    widgetData.price = price;
    widgetData.currency = currency;
    widgetData.rooms = thn.parseNumber(thn.objectGet(dataLayer, 'products', { first: false })?.length || window.rtNUMROOMS);

    return widgetData;
  };

  /**
    * @memberOf module:bs_207
    * @this thn.widgets.booking
    * @see {@link Price#get_promocode}
    *
    * @param {object} ctx - The context object.
    */
  engine.getPromocode = function getPromocode(ctx) {

    const promocode = (document.querySelector('.vsc-item-calendar-action-item-description') || {}).textContent;

    if (promocode) {
      ctx.promocode = promocode;
    }
    return ctx.promocode;
  };

  return engine;

}

export { factory };
